import React, { useEffect, useCallback} from 'react';

// styles
import './style.scss';

// antd component
import { notification } from 'antd';

// assets
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
//import CustomIcons from 'components/CustomIcons';

function NotificationHandleUpdate({
  Loading,
  Successful,
  isNew,
  // default props
  message,
  messageSuccess,
  description,
  descriptionError,
}) {
  // Loading Notifications
  useEffect(() => {
    if ((Loading && !Successful && !isNew) || (!isNew && Successful)) {
      updateNotification(Loading, isNew, Successful);
    }
  }, [
    Loading, isNew, Successful
  ]);

  const updateNotification = useCallback((Loading, isNew, Successful) => {
    return (
      notification.info({
        duration: 2,
        icon: (
          <>
            {Loading && !Successful && (
              <LoadingOutlined style={{ color: '#F59C05' }} />
            )}
            {Successful && <CheckCircleOutlined style={{ color: '#28A745' }} />}
          </>
        ),
        message: Successful ? messageSuccess : message,
        description: Successful
          ? description
          : descriptionError,
      })
    )
  }, [description, descriptionError, messageSuccess, message, Loading, isNew, Successful]);

  return <></>;
};

NotificationHandleUpdate.defaultProps = {
  message: `Actualisé!`,
  messageSuccess: `Actualisé!`,
  description: `Données enregistrées avec succès!`,
  descriptionError: 'Un instant…',
};

export default NotificationHandleUpdate;